import { useEffect, useState } from "react";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      "https://leetcode-apis-production.up.railway.app/leetcode/solutions/sahiljena",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => setBlogs(result))
      .catch((error) => console.log("error", error));
  }, []);
  return (
    <>
      <h2 className="text-xl font-semibold">Leetcode Articles</h2>
      {!blogs?.solutions && <p>Loading...</p>}
      {blogs?.solutions?.map((blog, i) => {
        return (
          <a target={"_blank"} href={"https://leetcode.com" + blog?.node?.url}>
            <div className="bg-gray-800 mt-3 p-2 rounded">
              <div className="flex justify-between">
                <div className="text-blue-500 text-md">
                  {i + 1}. {blog?.node?.questionTitle}
                </div>
                <div className="text-xs">{blog?.node?.viewCount} views</div>
              </div>
              <p className="text-sm">{blog?.node?.title}</p>
            </div>
          </a>
        );
      })}
    </>
  );
};

export default Blog;
